// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Headlines-H3-module--cls1--2j2-_","cls2":"Headlines-H3-module--cls2--2yCfU Headlines-H3-module--cls1--2j2-_"};